export const logisticsURLs = {
  // logistics
  ADD_LOGISTICS: 'stakeholder/add',
  UPDATE_LOGISTICS: `stakeholder/update`,
  GET_ALL_LOGISTICS: `stakeholder/get/all`,
  DELETE_LOGISTICS: `stakeholder/delete`,
  DEACTIVATE_LOGISTICS: `stakeholder/deactivate`,

  // loads
  GET_LOADS: 'load/get/all',
  LOADS_ACTIVE_USERS: `stakeholder/get/active/names`,
  FREIGHT_NAMES: `freight/get/name`,
  DELETE_LOADS: `load/delete`,
  DEACTIVATE_LOADS: `load/deactivate`,
  ADD_LOADS: `load/add`,
  UPDATE_LOADS: `load/update`,

  // freight
  ADD_FREIGHT: 'freight/add',
  GET_FREIGHT: 'freight/get/all',
  UPDATE_FREIGHT: 'freight/update/',
  DELETE_FREIGHT: 'freight/delete/',
  PATCH_FREIGHT: 'freight/deactivate/',

  // trailer
  ADD_TRAILER: 'trailer/add',
  GET_ALL_TRAILER: `trailer/get/all`,
  DEL_TRAILER: `trailer/delete/`,
  DEACTIVATE_TRAILER: `trailer/activate/`,
  UPDATE_TRAILER: `trailer/update/`,
  FILE_STATUS: `trailer/document/status/add?`,

  // truck
  GET_TRUCK: `truck/get/all`,
  UPDATE_TRUCK: `truck/update`,

  // DRIVERS LIST
  DRIVERS_LIST: 'trip/available',

  // maintenance
  ADD_MAINTENANCE: `report/maintenance/add`,
  GET_ALL_MAINTENANCE: `report/maintenance/get`,
  PART_DROPDOWN: `report/maintenance/dropdown`,
  VEHICLE_NUMBERS: `truck/dropdown`,
  VEHICLE_TYPE: `report/vehicle/details/dropdown`,

  // dispatch
  ADD_DISPATCH: `dispatch/add`,
  GET_DISPATCH_LIST: `dispatch/dropdown`,
  GET_DISPATCH_DATA: `dispatch/get/all`,
  DEACTIVATE_DISPATCH_DATA: `dispatch/activate/`,
  DELETE_DISPATCH: `dispatch/delete/`,
  UPDATE_DISPATCH: `dispatch/update/`,

  //inspection
  GET_INSPECTION: '/report/inspection',
  ADD_INSPECTION: 'report/inspection/add',

  // Vehicle Config Manager:
  GET_CONFIG_LIST: 'user/vehicle/maintenance/get/',
  ADD_CONFIG_LIST: 'user/vehicle/maintenance/add',
  UPDATE_CONFIG_LIST: 'user/vehicle/maintenance/update/part',
  DELETE_CONFIG_LIST: 'user/vehicle/maintenance/delete?'
};
